import { render } from "./IntegratorsAddView.vue?vue&type=template&id=3ae6bb6b"
import script from "./IntegratorsAddView.vue?vue&type=script&lang=js"
export * from "./IntegratorsAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__